import { Component, input, output } from '@angular/core';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-dialog-header',
	templateUrl: './dialog-header.component.html',
	styleUrls: ['./dialog-header.component.scss'],
	imports: [IconComponent],
})
export class DialogHeaderComponent {
	readonly title = input<string>();
	readonly sluitbaar = input(false);

	sluiten = output<void>();
}
